import React from 'react';

import {Box, Card, CardContent, Skeleton, Stack} from 'views/components';

/**
 * Mimics the cards to be used as a skeleton when data is loading
 * @return {React.JSX.Element}
 */
const JobCardSkeleton = () => {
  return (
    <Card
      variant="outlined"
      sx={{
        borderRadius: 3,
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <CardContent
        sx={{
          p: 3,
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          minHeight: 0,
        }}
      >
        <Stack spacing={2}>
          {/* Title row */}
          <Box sx={{display: 'flex', justifyContent: 'space-between', gap: 2}}>
            <Skeleton variant="text" width="60%" height={28} />
            <Skeleton variant="text" width={80} height={28} />
          </Box>

          {/* Description */}
          <Box>
            <Skeleton variant="text" height={18} />
            <Skeleton variant="text" height={18} />
            <Skeleton variant="text" width="80%" height={18} />
          </Box>

          {/* Salary info */}
          <Skeleton variant="text" width="70%" height={18} />

          {/* Chips */}
          <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
            {
              [...Array(4)].map((_, i) => (
                <Skeleton
                  key={i}
                  variant="rounded"
                  width={90}
                  height={32}
                  sx={{borderRadius: 999}}
                />
              ))
            }
          </Stack>
        </Stack>

        {/* Button */}
        <Box sx={{mt: 'auto', display: 'flex', justifyContent: 'flex-end'}}>
          <Skeleton variant="rounded" width={120} height={36} sx={{borderRadius: 999, mt: 1}} />
        </Box>
      </CardContent>
    </Card>
  );
};

export default JobCardSkeleton;
